import React from 'react'
import blobPath from './MyMapUtils/blobPath'
import GetfacilityTypeData from './MyMapUtils/GetfacilityTypeData';
const isLogin = window.SIMPL.isLogin;

export default function SearchResultItem(props) {

    return (
        <div className="sr-itemcontainer"
            id={props.data?.id}
                onMouseEnter={() => props.onEnterItem(props.data) }    
                onMouseLeave={() => props.onLeaveItem(props.data) }
                onClick={()=> isLogin ? window.open(window.location.origin + '/Detail/Details/' + props.data.id) : null }
            >
                <a className="sr-a" rel='noopener noreferrer' href="/#">{null}</a>
                <div className="sr-item">
                    <div className="sr-flex">
                        <div className="sr-flex-icon">
                            <div className="sr-flex-icondiv">
                                <img decoding="async" className="sr-item-icon" src={GetfacilityTypeData(props.data.type,"icon")}
                                    aria-hidden="true" alt="" />
                            </div>
                        </div>
                            <div className="sr-flex-info">
                                <div className="sr-flex-infodiv">
                                    <div className="sr-item-title">
                                        <div className="sr-item-titlevalue">
                                            <span style={{ fontWeight: 'bold' }}>{props.data.title}</span>
                                        </div>
                                    </div>
                                    <div className="sr-item-property"><span>{GetfacilityTypeData(props.data.type,"name")}</span></div>
                                    <div className="sr-item-property"><span>{props.data.address}</span></div>
                                    <div className="sr-item-property"><span>管理事務所：{props.data.componentManagerOffice}</span></div>
                                    <div className="sr-item-property"><span>施設コード：{props.data.identifier}</span></div>
                                    <div className="sr-item-property"><span>健全度　　：{props.data.overallHealthLevel}</span></div>
                                </div>
                            </div>
                        <div className="sr-flex-img">
                            <div className="sr-flex-imgdiv">
                                <img decoding="async" className="sr-item-img"
                                    src={blobPath(props.data.PhotoURL)}
                                    aria-hidden="true" alt=""
                                    onMouseEnter={(e) => props.onEnterImg(e, props.data.PhotoURL) }    
                                    onMouseLeave={(e) => props.onLeaveImg(e, props.data.PhotoURL) }
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="sr-line"></div>
            </div>
    );
}